import { useEffect, useState } from "react";
import { fetchJobPostings } from "Services/AdminServices/DocumentsStoreService";
import { fetchOnboardingEmployees } from "Services/AdminServices/OnBoardingService";
import { message } from "antd";

function useOnboarding() {
  const [selectedJobPostingId, setSelectedJobPostingId] = useState(null);
  const [jobPostings, setJobPostings] = useState([]);
  const [onboardingEmployees, setOnboardingEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleJobPostingChange = async (value) => {
    try {
      setLoading(true);

      const jobPostingId = value != null ? Number(value) : null;
      setSelectedJobPostingId(jobPostingId);

      const employees = await fetchOnboardingEmployees(jobPostingId);

      if (!Array.isArray(employees)) {
        setOnboardingEmployees([]);
        return;
      }

      const filtered = employees.filter(
        (emp) => emp.status === 7 || emp.status === 8
      );

      setOnboardingEmployees(filtered);
    } catch (error) {
      console.error(error);
      message.error("Failed to load onboarding employees");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        setLoading(true);

        const postings = await fetchJobPostings();
        setJobPostings(postings || []);

        const employees = await fetchOnboardingEmployees(null);

        if (Array.isArray(employees)) {
          setOnboardingEmployees(employees);
        } else {
          setOnboardingEmployees([]);
        }
      } catch (error) {
        console.error(error);
        message.error("Failed to load onboarding data");
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();
  }, []);

  return {
    handleJobPostingChange,
    jobPostings,
    onboardingEmployees,
    selectedJobPostingId,
    loading,
  };
}

export default useOnboarding;